(() => {
  const money = (cents, currency) => {
    if (document.documentElement.lang === 'ar') {
      const amount = Number(cents || 0) / 100;
      return `${new Intl.NumberFormat('ar-QA-u-nu-arab', {
        useGrouping: false,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount).replace(/٫/g, ',')} ر.ق`;
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang === 'ar' ? 'ar-QA-u-nu-arab' : 'en', {
        style: 'currency',
        currency: currency || 'QAR',
        signDisplay: 'exceptZero',
      }).format(Number(cents || 0) / 100);
    } catch (_error) {
      const sign = Number(cents) > 0 ? '+' : '';
      return `${sign}${(Number(cents || 0) / 100).toLocaleString(document.documentElement.lang === 'ar' ? 'ar-QA-u-nu-arab' : 'en')} ${document.documentElement.lang === 'ar' ? 'ر.ق' : (currency || 'QAR')}`;
    }
  };

  const readVariants = (picker) => {
    try {
      return JSON.parse(picker.querySelector('[data-mshq-product-variants]')?.textContent || '[]');
    } catch (_error) {
      return [];
    }
  };

  const selectedOptions = (picker) => {
    const selected = [];
    picker.querySelectorAll('[data-option-position]').forEach((control) => {
      if ((control.matches('input') && control.checked) || (control.matches('option') && control.selected)) {
        selected[Number(control.dataset.optionPosition) - 1] = control.value;
      }
    });
    return selected;
  };

  const updatePicker = (picker) => {
    const variants = readVariants(picker);
    const cards = [...picker.querySelectorAll('[data-frame-card]')];
    if (!variants.length || !cards.length) return;

    const selected = selectedOptions(picker);
    const frameControl = picker.querySelector('[data-option-position="2"]');
    const frameIndex = Number(frameControl?.dataset.optionPosition || 2) - 1;
    const matching = variants.filter((variant) =>
      variant.options.every((value, index) => index === frameIndex || !selected[index] || value === selected[index]),
    );
    const available = matching.filter((variant) => variant.available);
    const priced = available.length ? available : matching;
    const baseline = priced.length ? Math.min(...priced.map((variant) => Number(variant.price))) : 0;

    cards.forEach((card) => {
      const variant = matching.find((item) => item.options[frameIndex] === card.dataset.frameValue);
      const delta = variant ? Number(variant.price) - baseline : 0;
      const deltaNode = card.querySelector('[data-frame-price-delta]');
      if (deltaNode) deltaNode.textContent = variant ? money(delta, picker.dataset.currencyCode) : '';
      card.classList.toggle('is-unavailable', !variant?.available);
      card.setAttribute('aria-disabled', String(!variant?.available));
    });
  };

  const initialize = (root = document) => {
    root.querySelectorAll('variant-selects').forEach((picker) => {
      updatePicker(picker);
      if (picker.dataset.mshqOptionsBound === 'true') return;
      picker.dataset.mshqOptionsBound = 'true';
      picker.addEventListener('change', () => requestAnimationFrame(() => updatePicker(picker)));
    });
  };

  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();

  document.addEventListener('product-info:loaded', (event) => initialize(event.target));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
